module.exports = __webpack_public_path__ + "static/media/icon-no-syllabus.3aeb2f03.svg";